<template>
  <el-dialog title="级别" :visible.sync="dialogVisible" width="825px" height="360px" append-to-body :before-close="resetForm">
    <img src="./../../../../assets/images/level.jpeg" />
    <p>舞匣保留对赛事的评级，如有异议，可联系负责人微信：yuankang001</p>
  </el-dialog>
</template>

<script>

export default {
  data () {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    openModal () {
      this.dialogVisible = true;
    },
    resetForm () {
      this.dialogVisible = false;
    }
  },

  mounted () {

  }
}
</script>

<style lang="scss" scoped>
</style>